import { render, staticRenderFns } from "./frontCover.vue?vue&type=template&id=9d4d1d38&scoped=true"
import script from "./frontCover.vue?vue&type=script&lang=js"
export * from "./frontCover.vue?vue&type=script&lang=js"
import style0 from "./frontCover.vue?vue&type=style&index=0&id=9d4d1d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4d1d38",
  null
  
)

export default component.exports